module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA8CAYAAAAt3km7AAAABHNCSVQICAgIfAhkiAAAAUxJREFUaIHt2t9RwkAQgPFvU5GpwNAN2gTQhNKNZwWxItcHWIwDxpDkTPZmvye4IX9+s3MPzJzQadtqI8Lu/LXBSaIcAF5q2V/W7MPTh77hCHMrUQ6GE4DnVvf6PSnvpdcH2UhhKABU2VRLv0SORNhVpU3LKnJiQFMqrNiJBcxdAfNWwLwVMG8FzFsB81bAvBUwbwXMWwHzVsC8FTBvBcxbAfNWwLwVMG9VQFr6JTKUipyYKO+Vno/rlFZ1rCVJQTg7dnQ5S1XCCZ2rs1SWY1xS5XCsJdmC3PqVJ2B3Sj/W+y5aOfBqSt16YXDCAawI2Auy/oRZK5jeIJA1GGYtAfxtH/VeM/Zh/wS8a0rdRsMg6/4bDbImwawZpzcZZM0Cs6YAx+yj3vvNdaNudwJnm1K3LDAYtP+ygKxsMGvbalNBo8IjnP4rfULKBSq+L8pxnK+GVn5rAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(9).png
// module id = zMDJ
// module chunks = 1